import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from '../modal/modal'
import './../modal/modal.scss'
import { Grid } from '@material-ui/core'
import Button from 'react-bootstrap/Button';
import SelectInput from '../inputs/select'
import { ProposalType } from '../../util/enums'

function DownloadDialog(props) {
  const { open, handleDownloadDialog, downloadFile, templateOptions = [], type = '' } = props
  const [templatevalue, setTemplateValue] = useState('');

  useEffect(() => {
    if (open) {
      if (Array.isArray(templateOptions) && templateOptions.length) {
        let defaultOption;
        if (type === ProposalType.SUMMARY) {
          defaultOption = templateOptions.find(option => option.type === 'project_quote');
        } else if (type === ProposalType.DETAILED) {
          defaultOption = templateOptions.find(option => option.type === 'detailed_project_quote');
        }
        
        if (defaultOption) {
          setTemplateValue(defaultOption.value);
        } else {
          // Pre-select the first template option by default
          setTemplateValue(templateOptions[0].value);
        }
      } else {
        setTemplateValue('');
      }
    } else {
      setTemplateValue('');
    }
  }, [open, templateOptions, type])
  const submitForm = (fileFormat = 'pdf') => {
    if (!templatevalue) return;
    downloadFile(fileFormat, templatevalue)
  }
  let changeHandler = (e) => {
    setTemplateValue(e.target.value)
  }

  return (
    <Modal
      open={open}
      onClose={handleDownloadDialog}
      fullWidth={true}
      maxWidth='xs'
      modalHeading='Download Dialog'
      primary
      dataCy={props?.dataCy || props['data-cy'] || 'download-dialog'}
    >
      {(templateOptions.length > 0) && <><div className="col-12 mt-3">
        <SelectInput
          name={'templateSelect'}
          label={'Select Template'}
          items={templateOptions}
          value={templatevalue}
          onChange={(e) => changeHandler(e)}
          dataCy='template-select'
        />
      </div>
        {/* {templatevalue == '' && <h2 className="content-heading text-uppercase">Select File Format to Download</h2>} */}
        <div className="col-12 d-flex mt-3">
          <Button type="submit" className="ms-auto me-3 secondarybtn" onClick={() => submitForm('pdf')} data-cy="pdf-download">PDF</Button>
          <Button type="submit" className="secondarybtn me-auto" onClick={() => submitForm('docx')} data-cy="word-download">WORD</Button>
        </div>
      </>}
      {(templateOptions.length == 0) && <Grid container spacing={2} className="downloadVariation" alignItems={'center'} ng-else data-cy="download-variation">
        <Grid item xs={12} >
          <p data-cy="message">There is no document template uploaded for {props.downloadModuleName ? props.downloadModuleName : 'this Download'}. This can be added in Global Settings by an administrator.</p>
        </Grid>
      </Grid>}
    </Modal>
  )
}

DownloadDialog.defaultProps = {
  open: false
}

DownloadDialog.propTypes = {
  open: PropTypes.bool,
  handleDownloadDialog: PropTypes.func,
  downloadFile: PropTypes.func,
  handleTemplateChange: PropTypes.func
}

export default DownloadDialog;
